
// import React, { useState, useEffect } from 'react';
// import toast from 'react-hot-toast';
// import { useDispatch } from 'react-redux';
// import { updateCoupon } from '../../redux/actions/couponActions'; // Import your action creator for updating coupon

// const EditCoupon = ({ coupon, onCloseModal }) => {
//   const [couponData, setCouponData] = useState(coupon || {});
//   const dispatch = useDispatch();

//   useEffect(() => {
//     if (coupon) {
//       setCouponData(coupon);
//     }
//   }, [coupon]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCouponData((prevData) => ({ ...prevData, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // Ensure couponData contains all required fields
//       await dispatch(updateCoupon(coupon._id, couponData));  // Pass couponId and couponData
//       toast.success('Coupon updated successfully!');
//       onCloseModal(); // Close the modal after successful submission
//     } catch (error) {
//       console.error('Failed to update coupon:', error);
//       toast.error('Failed to update coupon!');
//     }
//   };

//   const formatDate = (date) => {
//     if (!date) return '';
//     const d = new Date(date);
//     return d.toISOString().split('T')[0];
//   };

//   return (
//     <div className="fixed inset-0 flex justify-center items-center bg-gray-600 bg-opacity-50 z-50">
//       <div className="bg-white p-6 rounded-md shadow-lg w-full max-w-lg">
//         <h2 className="text-xl font-bold mb-4">Edit Coupon</h2>

//         <form onSubmit={handleSubmit}>
//           <div className="mb-4">
//             <label className="block text-sm font-medium">Coupon Name</label>
//             <input
//               type="text"
//               name="name"
//               value={couponData.name}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               required
//             />
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium">Coupon Code</label>
//             <input
//               type="text"
//               name="code"
//               value={couponData.code}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               required
//             />
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium">Description</label>
//             <textarea
//               name="description"
//               value={couponData.description}
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               rows="3"
//             />
//           </div>

//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Discount Value</label>
//               <input
//                 type="number"
//                 name="discountValue"
//                 value={couponData.discountValue}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>

//             <div className="flex-1">
//               <label className="block text-sm font-medium">Discount Type</label>
//               <select
//                 name="discountType"
//                 value={couponData.discountType}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               >
//                 <option value="">Select Type</option>
//                 <option value="percentage">Percentage</option>
//                 <option value="flat">Flat</option>
//               </select>
//             </div>
//           </div>

//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Minimum Purchase</label>
//               <input
//                 type="number"
//                 name="minimumPurchase"
//                 value={couponData.minimumPurchase}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//               />
//             </div>

//             <div className="flex-1">
//               <label className="block text-sm font-medium">Usage Limit</label>
//               <input
//                 type="number"
//                 name="usageLimit"
//                 value={couponData.usageLimit}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//               />
//             </div>
//           </div>

//           <div className="mb-4 flex space-x-4">
//             <div className="flex-1">
//               <label className="block text-sm font-medium">Start Date</label>
//               <input
//                 type="date"
//                 name="startDate"
//                 value={formatDate(couponData.startDate)}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>

//             <div className="flex-1">
//               <label className="block text-sm font-medium">End Date</label>
//               <input
//                 type="date"
//                 name="endDate"
//                 value={formatDate(couponData.endDate)}
//                 onChange={handleChange}
//                 className="w-full p-2 border rounded-md"
//                 required
//               />
//             </div>
//           </div>

//           <div className="mb-4">
//             <label className="block text-sm font-medium">Is Active</label>
//             <select
//               name="isActive"
//               value={couponData.isActive ? 'true' : 'false'} // Ensure it's a boolean value
//               onChange={handleChange}
//               className="w-full p-2 border rounded-md"
//               required
//             >
//               <option value="true">Activate</option>
//               <option value="false">Deactivate</option>
//             </select>
//           </div>

//           <div className="flex justify-between items-center">
//             <button
//               type="button"
//               onClick={onCloseModal}
//               className="bg-gray-300 p-2 rounded-md"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               className="bg-blue-600 text-white p-2 rounded-md"
//             >
//               Save Changes
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditCoupon;


import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { updateCoupon } from '../../redux/actions/couponActions';

const EditCoupon = ({ coupon, onCloseModal }) => {
  const [couponData, setCouponData] = useState(coupon || {});
  const dispatch = useDispatch();

  useEffect(() => {
    if (coupon) {
      setCouponData(coupon);
    }
  }, [coupon]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCouponData(prev => ({ 
      ...prev, 
      [name]: name === 'isActive' ? value === 'true' : value 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await dispatch(updateCoupon(coupon._id, couponData));
      toast.success('Coupon updated successfully!');
      onCloseModal();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update coupon!');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800">Edit Coupon</h2>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6 max-h-[80vh] overflow-y-auto">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Coupon Name</label>
              <input
                type="text"
                name="name"
                value={couponData.name || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                placeholder="Enter coupon name"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Coupon Code</label>
              <input
                type="text"
                name="code"
                value={couponData.code || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all uppercase"
                placeholder="COUPON123"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea
                name="description"
                value={couponData.description || ''}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                rows="3"
                placeholder="Enter coupon description..."
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Discount Value</label>
                <input
                  type="number"
                  name="discountValue"
                  value={couponData.discountValue || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="0"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Discount Type</label>
                <select
                  name="discountType"
                  value={couponData.discountType || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all bg-white"
                  required
                >
                  <option value="">Select Type</option>
                  <option value="percentage">Percentage (%)</option>
                  <option value="flat">Flat Amount</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Minimum Purchase</label>
                <input
                  type="number"
                  name="minimumPurchase"
                  value={couponData.minimumPurchase || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="No minimum"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Usage Limit</label>
                <input
                  type="number"
                  name="usageLimit"
                  value={couponData.usageLimit || ''}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  placeholder="Unlimited"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={formatDate(couponData.startDate)}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={formatDate(couponData.endDate)}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
              <select
                name="isActive"
                value={couponData.isActive?.toString() || 'true'}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                required
              >
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-end pt-4">
            <button
              type="button"
              onClick={onCloseModal}
              className="w-full sm:w-auto px-6 py-2 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="w-full sm:w-auto px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium text-white transition-colors"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCoupon;